import { Component, Input, ViewChild } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexDataLabels,
    ApexPlotOptions,
    ApexStroke,
    ApexYAxis,
    ApexTitleSubtitle,
    ApexLegend,
    NgApexchartsModule,
    ApexGrid,
    ApexFill,
} from "ng-apexcharts";
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    fill: ApexFill;
    grid: ApexGrid;
    yaxis: ApexYAxis;
    labels: string[];
    colors: string[];
    title: ApexTitleSubtitle;
    legend: ApexLegend;
};

@Component({
    selector: 'app-tickets-in-progress',
    standalone: true,
    imports: [MatCardModule, NgApexchartsModule, DecimalPipe],
    templateUrl: './tickets-in-progress.component.html',
    styleUrl: './tickets-in-progress.component.scss'
})
export class TicketsInProgressComponent {

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    // isToggled
    isToggled = false;

    @Input() data: any = {
        name: '',
        dates: [],
        amounts: [],
    };

    // total
    total: number = 0;

    // average
    average: number = 0;

    constructor(
        public themeService: CustomizerSettingsService
    ) {
        this.chartOptions = {
            series: [
                {
                    name: 'Vulnerabilities',
                    data: this.data.amounts,
                }
            ],
            chart: {
                type: 'area',
                height: 200,
                toolbar: {
                    show: false,
                },
            },
            colors: [
                "#00cae3"
            ],
            plotOptions: {
                bar: {
                    dataLabels: {
                        position: "top" // top, center, bottom
                    }
                }
            },
            dataLabels: {
                enabled: false,
                offsetY: -25,
                style: {
                    fontSize: "12px",
                    colors: ["#304758"]
                }
            },
            stroke: {
                curve: "straight",
                width: 3
            },
            fill: {
                type: "gradient",
                gradient: {
                    opacityFrom: 0,
                    opacityTo: 0.5
                }
            },
            labels: this.data.dates,
            xaxis: {
                type: "datetime",
                axisBorder: {
                    show: false,
                    color: '#e0e0e0'
                },
                axisTicks: {
                    show: false,
                    color: '#e0e0e0'
                },
                labels: {
                    show: false,
                    style: {
                        colors: "#919aa3",
                        fontSize: "14px"
                    }
                },
                tooltip: {
                    enabled: false
                }
            },
            yaxis: {
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: false
                },
                labels: {
                    show: true,
                    style: {
                        colors: '#919aa3',
                        fontSize: '14px',
                    },
                },
            },
            title: {
                text: this.data.name,
                align: "left",
                offsetX: -9,
                style: {
                    fontWeight: '500',
                    fontSize: '15px',
                    color: '#475569'
                }
            },
            legend: {
                show: false
            },
            grid: {
                show: true,
                strokeDashArray: 5,
                borderColor: "#e0e0e0"
            }
        };
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // changeData
    changeData() {
        this.chartOptions.series = [{
            name: 'Vulnerabilities',
            data: this.data.amounts
          }];
        this.chartOptions.labels = this.data.dates;
        this.total = 0;
        this.data.amounts.forEach((element: number) => {this.total += element});
        this.average = this.total / this.data.amounts.length;
    }

}
